export type CategoryFilters = {
  time: string;
  duration: string;
  sort: string;
};

type Props = {
  value: CategoryFilters;
  onChange: (next: CategoryFilters) => void;
  onReset: () => void;
};

const groups: { key: keyof CategoryFilters; title: string; icon: string; options: { value: string; label: string }[] }[] = [
  {
    key: "time",
    title: "上传时间",
    icon: "ri-calendar-line",
    options: [
      { value: "all", label: "全部时间" },
      { value: "latest", label: "最新" },
      { value: "week", label: "近一周" },
      { value: "month", label: "近一月" },
    ],
  },
  {
    key: "duration",
    title: "视频时长",
    icon: "ri-timer-line",
    options: [
      { value: "all", label: "全部时长" },
      { value: "under1", label: "短于 1 分钟" },
      { value: "1to5", label: "1-5 分钟" },
      { value: "over5", label: "5 分钟以上" },
    ],
  },
  {
    key: "sort",
    title: "排序方式",
    icon: "ri-sort-desc",
    options: [
      { value: "latest", label: "最新发布" },
      { value: "hot", label: "最多播放" },
      { value: "likes", label: "最多点赞" },
    ],
  },
];

export default function FilterSidebar({ value, onChange, onReset }: Props) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-filter-3-line text-lg text-primary-500"></i>
          筛选条件
        </h2>
        <button
          type="button"
          onClick={onReset}
          className="text-xs font-label text-primary-600 transition-colors duration-200 hover:text-primary-700 cursor-pointer whitespace-nowrap"
        >
          重置
        </button>
      </div>

      {groups.map((group) => (
        <div key={group.key}>
          <h3 className="mb-3 flex items-center gap-2 text-sm font-label text-foreground-700">
            <i className={`${group.icon} text-base text-foreground-400`}></i>
            {group.title}
          </h3>
          <div className="flex flex-col gap-2">
            {group.options.map((opt) => {
              const active = value[group.key] === opt.value;
              return (
                <button
                  key={opt.value}
                  type="button"
                  onClick={() => onChange({ ...value, [group.key]: opt.value })}
                  className={`rounded-md px-3 py-2 text-left text-sm transition-colors duration-200 cursor-pointer ${
                    active
                      ? "bg-primary-500 font-label text-background-50"
                      : "bg-background-100 text-foreground-700 hover:bg-background-200"
                  }`}
                >
                  {opt.label}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}